// @flow
import * as React from 'react';
import { withTheme } from 'styled-components';
import RaisedButton from 'material-ui/RaisedButton';

import Proposition from 'common/modules/proposition/domain/proposition';
import PrintButton from 'advertisers/components/PrintButton';
import Location from 'common/helpers/location';
import PrintingService from 'common/services/PrintingService';

import withPropositionActions, { ACCEPT_ACTION, DECLINE_ACTION } from '../decorators/withPropositionActions';
import type { ActionType } from '../decorators/withPropositionActions';

type Props = {
  proposition: Proposition,
  actions: Array<{ label: string, onAction: () => any, type: ActionType }>,
  theme: any,
};

function PropositionDetailsActions(props: Props) {
  const { actions, theme, proposition } = props;

  const onPrintSales = () => {
    const url = Location.buildUrlFor('proposition-printing');
    const message = {
      estimation: proposition.estimation.toJSON(),
      radio: proposition.radio,
      dateRange: proposition.dateRange ? proposition.dateRange.toISO() : '',
    };

    PrintingService.printWindowWithData(url, 'SALES_DATA', message);
  };

  return (
    <div>
      <PrintButton onClick={onPrintSales} />
      {actions.length > 0 &&
        actions.map(({ label, onAction, type }) =>
          <RaisedButton
            key={label}
            label={label.toUpperCase()}
            onClick={onAction}
            primary={type === ACCEPT_ACTION}
            secondary={type === DECLINE_ACTION}
            style={{ margin: `0 ${theme.metrics.smallMargin}px` }}
          />,
        )
      }
    </div>);
}

export default withPropositionActions(withTheme(PropositionDetailsActions));



// WEBPACK FOOTER //
// ./src/advertisers/modules/propositions/components/PropositionDetailsActions.js